import { useRouter } from 'next/router';

const STATE_REGEX = /^[A-Z]{2}$/i
const MARKET_REGEX = /^[a-z]+(?:-[a-z]+)*$/i

export function useMarketParam() {
  const router = useRouter();

  const stateRegexMatch = STATE_REGEX.exec(String(router.query.state))
  const marketRegexMatch = MARKET_REGEX.exec(String(router.query.market))

  if (!stateRegexMatch || !marketRegexMatch) {
    return 'XX/xxx'
  }

  return `${stateRegexMatch[0].toUpperCase()}/${marketRegexMatch[0].toLowerCase()}`;
}
